import type { IServiceClient } from 'src/interfaces/serviceClient';
import type { IStore } from 'src/interfaces/store';

/**
 * Returns the store from a service client only when it is an object (not a string reference).
 * Use this to safely access store properties like countryCode, areas, _id.
 */
export const getServiceClientStore = (
    client: IServiceClient | null
): Partial<IStore> | null => {
    if (
        !client?.store ||
        typeof client.store === 'string' ||
        !('_id' in client.store)
    ) {
        return null;
    }
    return client.store;
};
